import axios from 'axios';
import type { RcmPasswordResetNewPasswordRequestData } from '../types';

const setNewPassword = async (data: RcmPasswordResetNewPasswordRequestData) => {
  await axios.post('/api/v2/password-reset/new-password', data);
};

export default setNewPassword;
